import { render, staticRenderFns } from "./MAbout.vue?vue&type=template&id=3b11690d&"
import script from "./MAbout.vue?vue&type=script&lang=js&"
export * from "./MAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports